import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StateProvider } from "./Context";
import { LoadingProvider } from "./common/LoadingContext";
import { NotificationProvider } from "./common/NotificationContext";
import UnSecuredPage from "./components/UnsecuredPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
if (window.self === window.top) {
  root.render(
    <StateProvider>
      <LoadingProvider>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </LoadingProvider>
    </StateProvider>
  );
} else {
  root.render(<UnSecuredPage />);
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
